import { Formik, FormikHelpers } from "formik";
import { getValidity } from "../../services/controllers";
import { Field, Form } from "../../designSystem/Form";
import { validateMandatory } from "../../utils/formUtils";
import { Button, ButtonSize } from "../../designSystem/Button";
import React, { useState } from "react";
import Container from "../Container";
import { APIGetValidityResponse } from "../../services/facade";

export interface ValidityFormProps {
  initialValues: ValidityFormValues;
  setValues: (
    formValues: ValidityFormValues,
    response: APIGetValidityResponse
  ) => void;
}

export interface ValidityFormValues {
    firstName?: string;
    lastName?: string;
    gender?: Gender;
    birthDate?: Date;
}

export enum Gender { Homme, Femme }

const getEligibilityYear = () => {
    const d = new Date()
    d.setMonth(d.getMonth() - 20)
    return d.getFullYear() - 1
}

const ValidityForm = (props: ValidityFormProps) => {

    const [isLoading, setIsLoading] = useState<boolean>(false)

    return (
      <Container
        className={isLoading ? "pointer-events-none" : ""}
        containerTitle={"vérification d'éligibilité"}
        containerDescription={
          `Pour être éligible à la prise de licence en ligne (licence Club annuelle uniquement), `
            + `vous ne devez pas avoir eu de licence Club annuelle depuis le 31 décembre ${getEligibilityYear()}.`
        }
      >
        <Formik
          initialValues={props.initialValues}
          onSubmit={(
            values: ValidityFormValues,
            {setSubmitting}: FormikHelpers<ValidityFormValues>
          ) => {
            setIsLoading(true);
            getValidity({
              // @ts-ignore
              Prenom: values.firstName,
              // @ts-ignore
              Nom: values.lastName,
              // @ts-ignore
              DateNaissance: values.birthDate,
              // @ts-ignore
              Sexe: Gender[values.gender] === 0 ? "M" : "F",
            }).then((response: APIGetValidityResponse) => {
              setIsLoading(false);
              props.setValues({
                firstName: values.firstName,
                lastName: values.lastName,
                // @ts-ignore
                birthDate: new Date(values.birthDate),
                // @ts-ignore
                gender: Gender[values.gender]
              }, response);
            });
            setSubmitting(false);
          }}
        >
          <Form>
            <Field
              id={"firstName"}
              name={"firstName"}
              placeholder={"Ex : Charlotte"}
              validate={validateMandatory}
              label={"Prénom"}
            />
            <Field
              id={"lastName"}
              name={"lastName"}
              placeholder={"Ex : Martin"}
              validate={validateMandatory}
              label={"Nom"}
            />
            <Field
              id={"birthDate"}
              name={"birthDate"}
              placeholder={"Ex : 23 / 03 / 1983"}
              type={"date"}
              validate={validateMandatory}
              label={"Date de naissance"}
            />
            <Field
              id={"gender"}
              name={"gender"}
              as={"select"}
              validate={validateMandatory}
              label={"Genre"}
            >
              <option key={"empty"} value="">Sélectionner</option>
              <option value="Homme">Homme</option>
              <option value="Femme">Femme</option>
            </Field>
            <div
              className={
                "flex items-center justify-center gap-x-8 gap-y-4 flex-wrap-reverse relative"
              }
            >
              {isLoading ? (
                <Button buttonSize={ButtonSize.FULL} isLoading={true}>Vérification...</Button>
              ) : (
                <Button buttonSize={ButtonSize.FULL} type="submit">Vérifier l'éligibilité</Button>
              )}
              {process.env.API_KEY}
            </div>
          </Form>
        </Formik>
      </Container>
    )
}

export default ValidityForm